import React from "react";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
} from "@mui/material";
import ScientificNameSelector from "../parts/ScientificNameSelector";

export default function SectionTypeTaxon({
  form,
  handleChange,
  errors,
  typeTaxaRadio,
  handleTypeTaxaRadio,
  refresh,
}) {
  return (
    <>
      <FormControl component="fieldset" margin="dense" fullWidth>
        <FormLabel component="legend">Type taxon designation</FormLabel>
        <RadioGroup
          row
          name="typeTaxaRadio"
          value={typeTaxaRadio}
          onChange={(e) => handleTypeTaxaRadio(e.target.value)}
        >
          <FormControlLabel
            value="own"
            control={<Radio />}
            label="This name itself is the type taxon"
            disabled={!form.id?.trim()}
          />
          <FormControlLabel
            value="other"
            control={<Radio />}
            label="Select another name as the type taxon"
          />
          <FormControlLabel value="none" control={<Radio />} label="No type taxon / not designated" />
        </RadioGroup>
      </FormControl>

      {typeTaxaRadio === "other" && (
        <ScientificNameSelector
          label="Type Taxon"
          valueId={form.type_taxa_id || ""}
          value={form.type_taxa_id || ""}
          isRequired
          disabled={false}
          onChange={(id) => handleChange("type_taxa_id", id || null)}
          onRefreshData={refresh}
          showInputLabel
          inlineAdd
          sx={{ mb: 2 }}
          error={errors?.typeTaxaId}
        />
      )}

      <TextField
        label="Type Remarks"
        value={form.type_remarks || ""}
        onChange={(e) => handleChange("type_remarks", e.target.value)}
        fullWidth
        multiline
        minRows={3}
        sx={{ mt: 2 }}
      />
    </>
  );
}